import { makeStyles } from '@material-ui/core/styles'
import { SCHEDULE_DESKTOP_COLUMN_CALENDAR, MODALS_INDENTATION_FOR_SMALL_SCREENS } from 'constants/breakpoints'

const useStyles = makeStyles((theme) => ({
  monthSliderContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      marginBottom: theme.spacing(2),
    },
  },
  currentMonthLabel: {
    minWidth: '7.7em',
    letterSpacing: 0.18,
    [theme.breakpoints.down(SCHEDULE_DESKTOP_COLUMN_CALENDAR)]: {
      minWidth: '7em',
    },
  },
  monthActions: {
    '& svg': {
      width: '0.5em',
      fill: 'currentColor',
    },
  },
  prevMonthButton: {
    marginLeft: theme.spacing(3.5),
    marginRight: theme.spacing(1),
    '& svg': {
      transform: 'rotate(180deg)',
    },
    [theme.breakpoints.down(MODALS_INDENTATION_FOR_SMALL_SCREENS)]: {
      marginLeft: theme.spacing(2.5),
    },
  },
}))

export default useStyles
